import { FunctionComponent } from 'react'
import useShowSharingLabels from '@hooks/useShowSharingLabels'
import styled, { css } from 'styled-components'
import useHasInvertedColors from '@hooks/useHasInvertedColors'
import useIsInHerotellingPage from '@hooks/useIsInHerotellingPage'
import useIsEndOfArticle from '@hooks/useIsEndOfArticle'

interface LabelComponentWrapperProps {
  children: React.ReactNode
  labelText: string
}

interface StyledWrapperProps {
  hasInvertedColors: boolean
}

const StyledWrapper = styled.div<StyledWrapperProps>`
  ${({
    theme: {
      typography: {
        subheads: {
          xsmall2: { bundledCSS: xsmall2subheadingCSS },
        },
      },
      colors: { textDefault, staticNeutral100 },
      spacing: { spacing4 },
    },
    hasInvertedColors,
  }) => css`
    ${xsmall2subheadingCSS};
    color: ${hasInvertedColors ? staticNeutral100 : textDefault};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${spacing4};
  `}
`

const LabelWrapper: FunctionComponent<LabelComponentWrapperProps> = ({
  children,
  labelText,
}) => {
  const endOfArticle = useIsEndOfArticle()
  const shouldShowSharingLabel = useShowSharingLabels() && !endOfArticle
  const isHerotellingArticle = useIsInHerotellingPage()
  const hasInvertedColors = useHasInvertedColors()

  if (!shouldShowSharingLabel) {
    return children
  }

  return (
    <StyledWrapper
      hasInvertedColors={hasInvertedColors || isHerotellingArticle}>
      {children} {labelText}
    </StyledWrapper>
  )
}
export default LabelWrapper
